import { WidgetComponentsIdEnum, WidgetType } from "~/components/widgets/types";
import { TemplateType } from "../constants/template-type";
import {
  ButtonTargetEnum,
  HighLightBannerConfig,
  ProductCarouselConfig,
} from "~/common/props/store.metadata";
import { cardProduct } from "~/__mocks__/store/mock-store-data";
import { TypeOptionConfig } from "../theme.type";

export const VITRINA = {
  HEADER: {
    SKIN: TemplateType.HEADER_4,
    PROPS: {
      OVER_BANNER: false,
      STICKY: true,
    },
  },
  COVER: TemplateType.COVER_1,
  PRODUCTS_FILTER: {
    SKIN: TemplateType.PRODUCTS_FILTER_SKIN_1,
    PROPS: {
      SHOW_QUANTITY: true,
      SHOW_TAGS: false,
      SHOW_QUANTITY_IN_TITLE: true,
    },
  },
  PRODUCT_CARD: TemplateType.PRODUCT_CARD_1,
  PRODUCTS_GRID: TemplateType.PRODUCTS_GRID_3,
  CATEGORIES: TemplateType.NONE,
  SCROLL_TOP_BUTTON: TemplateType.SCROLL_TO_TOP_1,
  FOOTER: TemplateType.FOOTER_1,
  POPUP_DETAIL: TemplateType.BEAUTY,
  STORE_INFO: {
    SKIN: TemplateType.STORE_INFO_SKIN_1,
    PROPS: {
      SHOW_VIDEO: true,
      SHOW_SOCIAL_BUTTONS: true,
    },
  },
  SLIDER_PRODUCT: TemplateType.SLIDER_PRODUCT_SKIN_2,
  PRODUCT_PAGE: TemplateType.PRODUCT_DETAIL_SKIN_1,
  PRODUCT_DETAIL_CARD: TemplateType.PRODUCT_DETAIL_CARD_SKIN_2,
  PRODUCT_TOPPING_SELECTOR: TemplateType.PRODUCT_TOPPING_SELECTOR_SKIN_1,
  SIDEBAR_MENU: TemplateType.SIDEBAR_MENU_PRINCIPAL_2,
  BUTTON: TemplateType.BUTTON_1,
  WIDGETS: [
    {
      id: WidgetComponentsIdEnum.product_carousel,
      type: WidgetType.PRODUCT_CAROUSEL_1,
      name: "Carrusel de productos",
      icon: "",
      path: "",
      configuration: {
        filter_type: TypeOptionConfig.random,
        category: "",
        products: TypeOptionConfig.random,
        highlight_background: false,
        product_ids: [],
      } as ProductCarouselConfig,
      index: 0,
      data: [],
    },
    {
      id: WidgetComponentsIdEnum.banner,
      type: WidgetType.BANNER_1,
      name: "Banner destacado",
      icon: "",
      path: "",
      configuration: {
        banner_type: "specific",
        banner_type_information: "product_service",
        banner_layout: "layout_1",
        highlight_background: true,
        product_id: cardProduct.id,
      } as HighLightBannerConfig,
      index: 1,
      data: {
        buttonTarget: ButtonTargetEnum.all,
        description: cardProduct.description,
        title: cardProduct.name,
        images: cardProduct.images,
      },
    },
  ],
};
